<template>
	<div>
		<div class="doctorPage doctorSeach managerPlan">
			<div class="selectSearch">
				<el-form ref="preservationform" :model="TaskStatisticByMonthParameter" class="qcFrom" :inline="true">
					<el-form-item label="状态">
						<el-select v-model="TaskStatisticByMonthParameter.Status" placeholder="请选择" size="mini"
							style="width:160px">
							<el-option label="全部" value=""></el-option>
							<el-option label="未开始" value="未开始"></el-option>
							<el-option label="进行中" value="进行中"></el-option>
							<el-option label="已完成" value="已完成"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker class="time mar4" v-model="pickerDate" @change="datePicker" type="monthrange"
							size="mini" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
							value-format="yyyy/MM" format="yyyy-MM"></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search" round>查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 中间内容 -->
			<div class="centerHome">
				<div class="ccHomel">
					<div class="compentTable">
						<el-table class="qcTable" :data="GetTaskStatisticByMonthList.Months" show-overflow-tooltip
							@expand-change="expandChange" :row-class-name="tableRowClassName" :row-key='getRowKeys'
							:expand-row-keys="expands" v-loading="loading">
							<el-table-column type="expand">
								<template slot-scope="scope">
									<task-table :list="scope.row.list" :type="1" v-loading="secondLoaidng"
										class="secondTable" />
								</template>
							</el-table-column>
							<el-table-column prop="CreateMonth" label="质控月份" min-width="100"></el-table-column>
							<el-table-column prop="Status" label="状态"></el-table-column>
							<el-table-column v-if="statusList!=15&&statusList!=50" prop="Process" label="质控进度">
								<template slot-scope="scope">
									<div class="progress">
										<div class="progress-bar progress-bar-success"
											:style="`width: ${scope.row.Process}`">
										</div>
										<span class="sr-only">{{scope.row.Process}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="HospitalCount" width='110' label="影像中心数量"></el-table-column>
							<el-table-column prop="TotalCount" label="报告总数">
								<template slot-scope="scope">
									<span>{{scope.row.TotalCount}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="CompleteDt" width='100' label="完成时间"></el-table-column>
							<!-- 	<el-table-column prop="" label="操作">
								<template slot-scope="scope">
									<span class="table-task-btn detail" @click="taskClick(scope.row)">查看任务</span>
								</template>
							</el-table-column> -->
						</el-table>
						<div class="pages">
							<el-pagination class="pageAll" layout="prev, pager, next"
								:total="GetTaskStatisticByMonthList.TotalCount"
								:page-size='TaskStatisticByMonthParameter.PageCount'
								:current-page='TaskStatisticByMonthParameter.PageIndex' @current-change='currentChange'>
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Api from '../../api'
	import axios from '@/js/api'
	import taskTable from '@/components/manager/taskTable.vue'
	export default {
		components: {
			taskTable,
		},
		data() {
			return {
				pickerDate: [],
				expands: [], //只展开一行放入当前行id
				getRowKeys(row) { //设置row-key只展示一行
					return row.CreateMonth
				},
				secondLoaidng: false
			}
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['TaskStatisticByMonthParameter', 'GetTaskStatisticByMonthList',
				'reviewName', 'statusList', 'SamplingTaskGuId', 'taskListTitle', 'listParameter'
			]),
			...Vuex.mapState('breadcrumb', ['loading', 'collapseflag', 'expertflag'])
		},
		activated() {
			this.clearInit();
			this.initMont();
		},
		mounted(){
			this.TaskStatisticByMonthParameter.PageIndex = 1;
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow', 'setLoading']),
			...Vuex.mapMutations('managerPlanList', ['setDoctorStatus', 'currentChangesSecond','setLoadings']),
			...Vuex.mapActions('managerPlanList', ['GetTaskStatisticByMonth', 'GetCreatedTaskList']),
			tableRowClassName({
				row,
				rowIndex
			}) {
				row.index = rowIndex;
			},
			expandChange(row, expandedRows) {
				let _this = this;
				if (expandedRows.length) { //说明展开了
					this.expands = [];
					if (row) {
						this.expands.push(row.CreateMonth); //只展开当前行id
					}
				} else { //说明收起了
					this.expands = [];
				}
				this.secondTableFun(row);
			},
			secondTableFun(row) {
				let _this = this;
				this.secondLoaidng = true;
				axios.ajaxGet('get', Api.api.manager.GetCreatedTaskList, {
					PageIndex: 1,
					PageCount: 999999,
					keyword: '',
					startDate: '',
					endDate: '',
					status: '0',
					CreateMonth: row.CreateMonth
				}).then(res => {
					_this.secondLoaidng = false;
					_this.setLoadings(false)
					row.list = res.data.SamplingTasks;
					row.list.map(res => {
						//全部0，已抽样 10， 已分发：15，进行中:20，已完成 50，已取消 -1
						if (res.Status == 5) {
							res.StatusCode = '已创建'
						}
						if (res.Status == 10) {
							res.StatusCode = '已抽样'
						}
						if (res.Status == 15) {
							res.StatusCode = '已分配'
						}
						if (res.Status == 20) {
							res.StatusCode = '进行中'
						}
						if (res.Status == 50) {
							res.StatusCode = '已完成'
						}
						if (res.Status == -1) {
							res.StatusCode = '已取消'
						}
					})
					_this.$set(_this.GetTaskStatisticByMonthList.Months, row.index, row);
				})
			},
			datePicker(event) {
				if (event != null) {
					this.TaskStatisticByMonthParameter.StartMonth = event[0].replace("/", "");
					this.TaskStatisticByMonthParameter.EndMonth = event[1].replace("/", "");
				}else{
					this.TaskStatisticByMonthParameter.StartMonth = '';
					this.TaskStatisticByMonthParameter.EndMonth = '';
				}
			},
			// //点击进入列表页
			// taskClick(row) {
			// 	this.expands.push(row.CreateMonth);
			// 	this.secondTableFun(row);
			// },
			search() {
				this.TaskStatisticByMonthParameter.PageIndex = 1;
				this.exportList = [];
				
				this.initMont();
			},
			//分页
			currentChange(val) {
				this.TaskStatisticByMonthParameter.PageIndex = val;
				this.initMont();
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			clearInit(){
				// this.TaskStatisticByMonthParameter.PageIndex = 1;
				this.TaskStatisticByMonthParameter.Status = '';
				this.TaskStatisticByMonthParameter.StartMonth = '';
				this.TaskStatisticByMonthParameter.EndMonth = '';
			},
			initMont() {
				this.GetTaskStatisticByMonth().then(() => {
					this.expands = [];
				});
			}
		}
	}
</script>
<style scoped="scoped">
	.doctorPage>>>.el-input__prefix {
		width: 92%;
	}

	.selectSearch {
		padding-right: 130px;
	}

	.doctorPage>>>.el-table__expanded-cell[class*=cell] {
		padding: 0 !important;
	}

	.secondTable {
		padding: 25px;
	}
</style>
